module.exports = __webpack_public_path__ + "static/media/map-marker.864ad362.svg";